import React, { useCallback } from 'react';

import { Translator } from 'ggApp/modules/translator/components';

import {
    StyledModal,
    Container,
    Title,
    LinkToPDF,
    NextArrow,
    HorizontalDiv,
    EnergySpecImage,
    Loading,
} from './styles';

interface EnergySheetModalProps {
    modalRef: any;
    onOpen: () => void;
    loading: boolean;
    imageUrl: string | undefined;
    pdfLinkUrl: any;
}

const EnergySheetModal = ({
    modalRef,
    onOpen,
    loading,
    imageUrl,
    pdfLinkUrl,
}: EnergySheetModalProps) => {
    const createModalRef = useCallback(
        (newModal) => {
            modalRef(newModal);
        },
        [modalRef],
    );

    return (
        <StyledModal modalRef={createModalRef} onOpen={onOpen} closeIcon>
            {loading ? (
                <Loading />
            ) : (
                <Container data-testid="energy-label-modal">
                    <Title>
                        <Translator tk="ENERGY_LABEL_ENERGY_CLASS" />
                    </Title>
                    <HorizontalDiv>
                        <LinkToPDF href={pdfLinkUrl} target="_blank">
                            <Translator tk="ENERGY_LABEL_INFO_SHEET" />
                        </LinkToPDF>
                        <NextArrow />
                    </HorizontalDiv>
                    <EnergySpecImage src={imageUrl} alt="Product information sheet" />
                </Container>
            )}
        </StyledModal>
    );
};

export default EnergySheetModal;
